<template>
  <section class="views">
    <headers select="4"></headers>
    <div class="views_content">
      <div class="views_banner">
        <img :src="require('@/assets/image/hodgepodge/h5banner.jpg')" alt="" />
      </div>

      <!-- 比赛类型Tab -->
      <!-- <div class="competition-types">
        <div class="type-tabs">
          <div
            v-for="item in competitionType"
            :key="item.value"
            @click="changeCompetition(item.value)"
            :class="{ active: item.value === currentCompetition }"
            class="tab-item"
          >
            {{ item.title }}
          </div>
        </div>
      </div> -->

      <div class="viewsBoxTab">
        <div class="viewsTab" ref="timeSlide">
          <ul>
            <li
              v-for="(item, index) in tabColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select == index ? 'select' : ''"
              :ref="`tab${index}Ref`"
            >
              <div>{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="select === 0" class="shortlisted-query">
        <div class="contentFrom_title">入圍名單查詢</div>
        <div class="plateUlsCentent6">
          <ul>
            <li>
              <div class="prompt" style="cursor: pointer">
                <div
                  :class="choose == 0 ? 'highlight' : ''"
                  @click="chooseBut(0)"
                >
                  個人報名
                </div>
                <div
                  :class="choose == 1 ? 'highlight' : ''"
                  @click="chooseBut(1)"
                >
                  學校報名
                </div>
              </div>

              <div class="row-input" v-if="choose == 0">
                <!-- <div class="input-name-1">參賽者電話</div> -->
                <div class="promptInput2">
                  <div class="lis">
                    <div class="lisLife">
                      <!-- <img :src="require('@/assets/image/hk.png')" />
										<span>+852</span> -->
                      <CountryCodeSelector
                        :searchbar="false"
                        :countryCode.sync="prefix"
                        style="width: 75px; margin-right: 5px"
                      ></CountryCodeSelector>
                    </div>
                    <input
                      class="lisRight"
                      type="text"
                      placeholder="請輸入參賽電話"
                      value=""
                      v-model.trim="from.phone"
                    />
                  </div>
                </div>
              </div>
              <div class="row-input" v-if="choose == 1">
                <!-- <div class="input-name">學校編號</div> -->
                <input
                  class="promptInput"
                  placeholder="請輸入學校編號"
                  v-model.trim="from.schoolCode"
                />
                <!-- <input
                  class="promptInput"
                  placeholder="請輸入參賽郵箱"
                  v-model.trim="from.email"
                /> -->
              </div>
            </li>
            <li v-if="choose == 0">
              <!-- <div class="prompt">姓名</div> -->
              <div class="row-input">
                <!-- <div class="input-name-1">參賽者姓名</div> -->
                <input
                  class="promptInput"
                  placeholder="請輸入參賽者姓名"
                  v-model="from.school_name"
                />
              </div>
            </li>
            <template v-if="choose == 1">
              <li>
                <div class="row-input">
                  <!-- <div class="input-name">學生編號</div> -->
                  <input
                    class="promptInput"
                    placeholder="請輸入登入編號"
                    v-model="from.studentCode"
                  />
                </div>
              </li>
              <!-- <div class="input-name">學生密碼</div> -->
              <!-- <li>
                <div class="row-input">
                  <input
                    class="promptInput"
                    placeholder="請輸入學生密碼"
                    v-model="from.password"
                  />
                </div>
              </li> -->
            <li>
              <!-- <div class="prompt">姓名</div> -->
              <div class="row-input">
                <!-- <div class="input-name-1">參賽者姓名</div> -->
                <input
                  class="promptInput"
                  placeholder="請輸入參賽者姓名"
                  v-model="from.school_name"
                />
              </div>
            </li>
            </template>
          </ul>

          <div
            class="but"
            @click="finalistsBut ? onFinalists() : ''"
            style="cursor: pointer"
          >
            查詢
          </div>
        </div>
      </div>
      <div class="viewTabContent">
        <div class="ulsTab" ref="tabSlideTwo">
          <ul>
            <li
              v-for="(item, index) in tabColumns[select].dataTab"
              :key="index"
              :class="selectTwo == item.id ? 'select' : ''"
              @click="tabButTwo(item.id)"
              :ref="`tab${item.id}RefTwo`"
            >
              <div>{{ item.name }}</div>
              <div>（{{ item.fzhu }}）</div>
            </li>
          </ul>
        </div>

        <div class="box">
          <ul
            v-if="
              select === 2 &&
              currentCompetition == '1' &&
              finalRankingList.length
            "
          >
            <li class="weiyitop">
              <div>獎項</div>
              <div>姓名</div>
              <div>電話/學號</div>
            </li>
            <li class="lis" v-for="(item, index) in finalRankingList" :key="index">
              <div>{{ item.award }}</div>
              <div>{{ item.studentName }}</div>
              <div>{{ getDisplayField(item) }}</div>
            </li>
          </ul>
          <ul v-else-if="select === 2">
            <div class="wu_center_custom">本組別暫無決賽成績。</div>
          </ul>
          <ul v-else-if="selectTwo === 10 && select === 0">
            <div class="wu_center_custom">經綜合評定，本組別參賽學生成績未達本次複賽入圍標準，很遺憾本屆暫無學生晉級複賽。</div>
          </ul>
          <ul v-else-if="selectTwo === 10 && select === 1">
            <div class="wu_center_custom">很遺憾本屆暫無學生晉級決賽。</div>
          </ul>
          <template v-else>
            <ul v-if="selectTwo !== 10 && currentCompetition == '1' && select !== 2">
              <li class="weiyitop">
                <div>參賽序號</div>
                <div>姓名</div>
                <div>電話/學號</div>
                <div v-if="select == 1">入圍/獎項</div>
              </li>

              <li class="lis" v-for="(item, index) in queryUserList" :key="index">
                <div>{{ item.competitionId }}</div>
                <div>{{ item.studentName }}</div>
                <div>{{ item.studentCode || item.phone }}</div>
                <div v-if="select == 1">
                  入圍決賽
                  <!-- {{
                    item.ranking <= 6
                      ? "入圍決賽"
                      : item.ranking >= 7 && item.ranking <= 10
                      ? "優異獎"
                      : ""
                  }} -->
                </div>
              </li>
            </ul>
          </template>
          <!-- <ul v-else-if="currentCompetition == '2' && select == 0">
            <li class="weiyitop">
              <div>序號</div>
              <div>學校/機構名</div>
              <div v-if="select == 0">入圍/獎項</div>
            </li>

            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>{{ item.competitionId }}</div>
              <div>{{ item.agencyName }}</div>
              <div v-if="select == 0">
                {{ item.ranking <= 3 ? "入圍決賽" : "優異獎" }}
              </div>
            </li>
          </ul> -->
          <!-- <ul v-else-if="currentCompetition == '2' && select == 1">
            <li class="weiyitop">
              <div>獎項</div>
              <div style="width: 66%">學校/機構名</div>
            </li>
            <li
              class="lis"
              v-for="(item, index) in rankingUserList"
              :key="index"
            >
              <div>
                {{
                  index == 0
                    ? "金獎"
                    : index == 1
                    ? "銀獎"
                    : index == 2
                    ? "銅獎"
                    : "優異獎"
                }}
              </div>
              <div style="width: 66%">{{ item.agencyName }}</div>
            </li>
          </ul> -->
          <!-- <ul v-else-if="currentCompetition == '1' && select == 2">
            <li class="weiyitop">
              <div>獎項</div>
              <div>姓名</div>
              <div>電話/學號</div>
            </li>
            <li
              class="lis"
              v-for="(item, index) in rankingUserList"
              :key="index"
            >
              <div v-if="item.competitionId === 22687">
                {{
                  "優異獎"
                }}
              </div>
               <div v-else>
                {{
                  index == 0 ? "金獎" : [1, 2].includes(index) ? "銀獎" : [3, 4, 5].includes(index) ? "銅獎" : "優異獎"
                }}
              </div>
              <div>{{ item.studentName }}</div>
              <div>{{ item.studentCode || item.phone }}</div>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
    <!-- 未入圍/成功入園 -->
    <van-popup
      v-model="newShortZZC"
      :round="true"
      :lock-scroll="false"
      :style="{ width: '80%' }"
    >
      <div class="newShortBox">
        <div class="list" v-if="newShortActive == 1">
          <!-- <div class="lis lisCenten"> <van-image width="149px" :src="require('@/assets/image/fusai/yes.png')" /> </div> -->
          <div class="ulst">
            <ul>
              <li>姓名</li>
              <li>組別</li>
              <li>分數</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText">
            恭喜你，成功入圍複賽<br />
            <!-- <span v-if="userObj.finalStatus == 2"
              >恭喜您，成功入圍決賽，<br />請仔細閱讀入圍電郵。</span
            >
            <span
              v-else-if="
                userObj.finalStatus == 1 &&
                  userObj.ranking >= 7 &&
                  userObj.ranking <= 10
              "
              >您的成績未能入圍決賽，<br />獲得優異獎。</span
            >
            <span v-else
              >很遺憾，您的成績未能獲獎，<br />非常感謝您的參與。</span
            > -->
          </div>
        </div>

        <div class="list" v-if="newShortActive == 2">
          <div class="ulst">
            <ul>
              <li>姓名</li>
              <li>組別</li>
              <li>分數</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText">
            很遗憾，您的成績未能入圍複賽，<br />非常感謝您的參與。
            <!-- <span v-if="userObj.finalStatus == 2"
              >恭喜您，成功入圍決賽，<br />請仔細閱讀入圍電郵。</span
            >
            <span
              v-else-if="
                userObj.finalStatus == 1 &&
                  userObj.ranking >= 7 &&
                  userObj.ranking <= 10
              "
              >您的成績未能入圍決賽，<br />獲得優異獎。</span
            >
            <span v-else
              >很遺憾，您的成績未能獲獎，<br />非常感謝您的參與。</span
            > -->
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 複賽指引 -->
    <RematchModal
      style="z-index: 9999"
      v-if="isRematch"
      @cancel="isRematch = false"
    ></RematchModal>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
import CountryCodeSelector from "@/components/CountryCodeSelector";
import RematchModal from "@/components/rematchModal/index.vue";

const FINAL_RESULT_MAP = {
  1: [
    { award: "金獎", studentName: "魏家沛", studentCode: "HLKG003", phone: "++852-55429521" },
    { award: "銀獎", studentName: "王詩琳", phone: "+852-63601516" },
    { award: "銀獎", studentName: "陳欣芸", studentCode: "wghckhkg-4", phone: "++852-95422836" },
    { award: "銅獎", studentName: "游雅媛", studentCode: "HLKG002", phone: "++852-55429521" },
    { award: "銅獎", studentName: "黃慕恆", phone: "+852-91455252" },
    { award: "銅獎", studentName: "馬樂賢", phone: "+852-53699348" },
    { award: "優異獎", studentName: "徐艾辰", phone: "+852-67631166" },
    { award: "優異獎", studentName: "李文采", phone: "+852-95770608" },
    { award: "優異獎", studentName: "顏語瑞", studentCode: "HLKG004", phone: "++852-55429521" },
    { award: "優異獎", studentName: "何玥蓉", phone: "+852-70102095" },
  ],
  2: [
    { award: "金獎", studentName: "杜祉穎", phone: "****2803" },
    { award: "銀獎", studentName: "高研芯", phone: "****2152" },
    { award: "銅獎", studentName: "劉星瑤", phone: "****2803" },
    { award: "銅獎", studentName: "石智宇", phone: "****0608" },
    { award: "銅獎", studentName: "董鈺瑩", phone: "****2803" },
    { award: "優異獎", studentName: "沈因時", studentCode: "*i5", phone: "" },
    { award: "優異獎", studentName: "韋昊瑜", phone: "****2198" },
    { award: "優異獎", studentName: "李沐苒", phone: "****6560" },
    { award: "優異獎", studentName: "肖芊玥", phone: "****0608" },
  ],
  3: [
    { award: "金獎", studentName: "江韋孜", studentCode: "wkf20251053", phone: "++852-59311212" },
    { award: "銀獎", studentName: "張凱傑", studentCode: "AAPS05", phone: "++852-90125523" },
    { award: "銀獎", studentName: "梁鈞甯", phone: "+852-59635863" },
    { award: "銅獎", studentName: "張芊雪", phone: "+852-64075156" },
    { award: "銅獎", studentName: "陸憬翌", phone: "+852-56668570" },
    { award: "銅獎", studentName: "袁梓菡", phone: "+852-98620293" },
    { award: "優異獎", studentName: "韓悅晴", phone: "+852-54037521" },
    { award: "優異獎", studentName: "余梓瑤", phone: "+852-59839591" },
    { award: "優異獎", studentName: "蘇珮博", phone: "+852-96188158" },
    { award: "優異獎", studentName: "梁浚桻", phone: "+852-56085530" },
  ],
  4: [
    { award: "金獎", studentName: "周天易", phone: "+852-63551653" },
    { award: "銀獎", studentName: "李芃萱", phone: "+852-70841672" },
    { award: "銀獎", studentName: "徐洛晞", phone: "+852-62056028" },
    { award: "銅獎", studentName: "葉峻銘", phone: "+86-13924598675" },
    { award: "銅獎", studentName: "陳欣妤", phone: "+852-96599969" },
    { award: "銅獎", studentName: "周思遠", phone: "+852-67483765" },
    { award: "優異獎", studentName: "李凌菲", phone: "+852-95890188" },
    { award: "優異獎", studentName: "黎睿知", phone: "+852-61396102" },
    { award: "優異獎", studentName: "徐嘉躍", phone: "+852-97111990" },
    { award: "優異獎", studentName: "何曾柳", phone: "+852-70102095" },
  ],
  5: [
    { award: "金獎", studentName: "陳旺田", phone: "+852-59566729" },
    { award: "銀獎", studentName: "林珏鋒", phone: "+852-56206168" },
    { award: "銀獎", studentName: "陳梓琳", phone: "+852-54096542" },
    { award: "銅獎", studentName: "蔡鎬宇", phone: "+852-66769854" },
    { award: "銅獎", studentName: "羅樂誠", phone: "+852-68997872" },
    { award: "銅獎", studentName: "盛糖", phone: "+852-55133400" },
    { award: "優異獎", studentName: "彭一心", phone: "+852-94899868" },
    { award: "優異獎", studentName: "方敏祺", phone: "+852-54815743" },
  ],
  6: [
    { award: "金獎", studentName: "王睿澤", phone: "+852-56393626" },
    { award: "銀獎", studentName: "王語淇", phone: "+852-61953130" },
    { award: "銀獎", studentName: "徐姜屹", phone: "+852-66417226" },
    { award: "銅獎", studentName: "王婧琪", studentCode: "S23162", phone: "++86-13410580909" },
    { award: "銅獎", studentName: "劉子清", phone: "+852-70105292" },
    { award: "銅獎", studentName: "張雅婷", phone: "+852-54486881" },
    { award: "優異獎", studentName: "黎諾源", phone: "****6910" },
    { award: "優異獎", studentName: "郭雯欣", phone: "+852-96090402" },
    { award: "優異獎", studentName: "譚天", studentCode: "s241225", phone: "++852-66326693" },
  ],
  7: [
    { award: "金獎", studentName: "許銘賢", studentCode: "hclmhmy", phone: "++852-53164099" },
    { award: "銀獎", studentName: "楊大福", studentCode: "hcwmc5", phone: "++852-66819100" },
    { award: "銅獎", studentName: "吳玥瑾", studentCode: "hcwmc3", phone: "++852-66819100" },
    { award: "優異獎", studentName: "黃子雲", studentCode: "hclmwtw", phone: "++852-61792818" },
    { award: "優異獎", studentName: "譚梓詠", studentCode: "hclmttw", phone: "++852-64800240" },
    { award: "優異獎", studentName: "吳素馨", studentCode: "hclmnsh", phone: "++852-64800240" },
  ],
  9: [
    { award: "金獎", studentName: "張婷婷", phone: "+852-69791589" },
    { award: "銀獎", studentName: "羅梓傑", phone: "****0748" },
    { award: "銅獎", studentName: "郭柏賢", phone: "+852-95770608" },
    { award: "優異獎", studentName: "羅梓晴", phone: "****0748" },
    { award: "優異獎", studentName: "高艾娜", studentCode: "Lyla", phone: "++852-92882803" },
    { award: "優異獎", studentName: "Lumisa Thapa", studentCode: "63088224", phone: "++852-95226755" },
  ],
  10: [],
  11: [
    { award: "金獎", studentName: "娜薇雅", studentCode: "20248006", phone: "++852-68599292" },
    { award: "銀獎", studentName: "尚康賢", studentCode: "20227033", phone: "++852-63001175" },
    { award: "銅獎", studentName: "NARAYANAN Vishwa", studentCode: "20227029", phone: "++852-63978856" },
    { award: "優異獎", studentName: "馮晉", phone: "+852-63454745" },
    { award: "優異獎", studentName: "龔芷澄", studentCode: "20237006", phone: "++852-64612829" },
    { award: "優異獎", studentName: "Kim Yungbin", phone: "+852-68105452" },
  ],
};

export default {
  name: "views",
  components: {
    headers,
    CountryCodeSelector,
    RematchModal,
  },
  data() {
    return {
      isRematch: false,
      // 比赛类型：个人赛 1 /团体赛 2
      currentCompetition: "1",
      competitionType: [
        {
          title: "個人賽",
          value: "1",
        },
        {
          title: "團體赛",
          value: "2",
        },
      ],
      tabColumns1: [
        {
          id: "0",
          name: "初賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
        {
          id: "1",
          name: "複賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
        {
          id: "2",
          name: "決賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
              // competitionId: [18271, 19815, 18270, 21748, 18294, 21291],
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
              // competitionId: [19820, 19235, 19818, 18303, 19797, 21484],
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
              // competitionId: [18498, 20958, 18552, 21780, 20825, 18590],
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
              // competitionId: [18376, 18447, 20005, 18366, 21545, 18298],
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
              // competitionId: [19782, 22368, 22327, 21334, 21767, 20439],
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
              // competitionId: [22242, 18587, 20154, 20158, 22082, 20159],
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
              // competitionId: [21197, 22684, 22685, 22768, 22769],
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
      ],
      tabColumns2: [
        {
          id: "0",
          name: "初賽成績",
          dataTab: [
            {
              name: "幼稚園組",
              fzhu: "K1-K3",
            },
            {
              name: "小學初級組",
              fzhu: "P1-P3",
            },
            {
              name: "小學高級組",
              fzhu: "P4-P6",
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
            },
          ],
        },
        {
          id: "2",
          name: "決賽成績",
          dataTab: [
            {
              name: "幼稚園組",
              fzhu: "K1-K3",
              competitionId: [92, 94, 96],
            },
            {
              name: "小學初級組",
              fzhu: "P1-P3",
              competitionId: [99, 125, 134],
            },
            {
              name: "小學高級組",
              fzhu: "P4-P6",
              competitionId: [126, 111, 110],
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              competitionId: [106, 120, 119],
            },
          ],
        },
      ],
      select: 2,
      selectTwo: 1,
      choose: 0, //查詢的下標
      from: {
        school_name: null,
        email: null,
        phone: null,
      },
      prefix: 852,
      finalistsBut: true,
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1,
      userObj: {
        competitionGroup: 1, //組別
        score: null, //分數
        studentName: null, //名字
      },
      queryUserList: [],
    };
  },
  computed: {
    tabColumns() {
      return this.currentCompetition === "1"
        ? this.tabColumns1
        : this.tabColumns2;
    },
    finalRankingList() {
      if (this.currentCompetition !== "1" || this.select !== 2) {
        return [];
      }
      return FINAL_RESULT_MAP[this.selectTwo] || [];
    },
  },

  watch: {
    select(val) {
      if (val) {
        console.log("發送改變", val);
      }
    },
  },
  created() {},
  mounted() {
    this.getScoreList(1);
    this.$nextTick(() => {
      setTimeout(() => {
        this.scrollLeftTo(2);
      }, 1000);
    });
  },
  methods: {
    changeCompetition(value) {
      this.currentCompetition = value;
      if (this.currentCompetition == "1") {
        this.select = 2;
      } else {
        this.select = 1;
      }
      this.selectTwo = 1;
      // this.getScoreList(1);
    },
    // 组别切换
    tabButTwo(e) {
      this.selectTwo = e;
      this.getScoreList(1);
      this.scrollLeftToTwo(e);
      // 触发滑动方法
      this.scrollLeftTo(e);
    },
    tabBut(e) {
      this.select = e;
      this.selectTwo = 1;
      this.getScoreList(1);
      // 触发滑动方法
      this.scrollLeftTo(e);
    },
    // 滑动
    scrollLeftTo(name) {
      const ref = `tab${name}Ref`;
      const nav = this.$refs.timeSlide;
      console.log("额:", this.$refs.timeSlide.offsetWidth);
      const title = this.$refs[ref][0];
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
    // 滑动
    scrollLeftToTwo(name) {
      const ref = `tab${name}RefTwo`;
      const nav = this.$refs.tabSlideTwo;
      // console.log("额:", this.$refs.tabSlideTwo.offsetWidth);
      const title = this.$refs[ref][0];
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
    // 切換
    chooseBut(e) {
      this.choose = e;
    },
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 入圍按鈕提交
    onFinalists() {
      let params;

      if (this.choose == 0) {
        if (this.from.school_name == "" || this.from.school_name == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }
        // 手機
        if (!this.validator_phone(this.from.phone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }

        params = {
          studentName: this.from.school_name,
          // prefix: this.prefix,
          phone: this.from.phone,
          email: null,
        };
      } else if (this.choose == 1) {
        const { schoolCode, studentCode, password, school_name } = this.from;
        if (schoolCode == "" || schoolCode == null) {
          this.$toast("請輸入學校編號 !");
          return;
        }
        if (studentCode == "" || studentCode == null) {
          this.$toast("請輸入登入編號 !");
          return;
        }
        // if (password == "" || password == null) {
        //   this.$toast("請輸入學生密碼 !");
        //   return;
        // }
        if (school_name == "" || school_name == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }

        params = {
          schoolCode,
          studentCode,
          password,
          studentName: school_name,
        };
      }

      params.scoreType = this.select + 1;
      params.competitionType = 8;
      this.finalistsBut = false;
      this.$toast.loading({
        message: "正在查詢中...",
        duration: 0,
        forbidClick: true,
      });
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.finalistsBut = true;
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            //请求成功
            // this.$toast.success('獲取成功');
            this.userObj.competitionGroup = response.data.data.competitionGroup; //組別
            this.userObj.score = response.data.data.score; //分數
            this.userObj.studentName = response.data.data.studentName; //名字
            this.userObj.finalStatus = response.data.data.finalStatus; // 1是优异奖  2是入围决赛
            this.userObj.ranking = response.data.data.ranking; // 排名

            this.$toast.clear();
            if (response.data.data.shortlisted) {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 1; //1是成功  2是失敗
            } else {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.finalistsBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getScoreList(pageNum) {
      if (this.currentCompetition === "1" && this.select === 2) {
        this.queryUserList = [];
        return;
      }
      this.$toast.loading({
        message: "正在查詢中...",
        duration: 0,
        forbidClick: true,
      });
      let groupId = this.selectTwo;
      let competitionType = this.currentCompetition === "1" ? 8 : 2;
      let scoreType = 1;
      if (this.currentCompetition === "1" && this.select != 0) {
        scoreType = 3;
      }

      let params =
        "?groupId=" +
        groupId +
        "&competitionType=" +
        competitionType +
        "&scoreType=" +
        scoreType +
        "&pageNum=" +
        pageNum +
        "&pageSize=" +
        100;

      const api =
        this.currentCompetition === "1"
          ? this.$api.promotionStudentList
          : this.$api.promotionCompetitionList;

      this.$axios
        .get(api + params)
        .then((response) => {
          this.$toast.clear();
          let arr = response.data.rows;
          if (pageNum === 1) {
            this.queryUserList = arr;
          } else {
            this.queryUserList = [...this.queryUserList, ...arr];
          }
          // 数据最多返回100条，超出请求2次
          if (response.data.total > 100 && pageNum === 1) {
            this.getScoreList(2);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getDisplayField(item) {
      if (item.studentCode) {
        const studentCode = String(item.studentCode).trim();
        return studentCode ? `*${studentCode.slice(-2)}` : "--";
      }

      if (item.phone) {
        const phone = String(item.phone).replace(/\D/g, "");
        return phone ? `****${phone.slice(-4)}` : "--";
      }

      return "--";
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-types {
  position: sticky;
  top: 0;
  width: 100%;
  margin-bottom: 30px;
  background: #d34a00;
  z-index: 99;
  .type-tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    .tab-item {
      min-width: 2rem;
      padding: 0.35rem 0.12rem;
      color: #fff;
      cursor: pointer;
      font-size: 0.32rem;

      &.active {
        font-weight: 600;
        color: #903300;
        background-image: url("~@/assets/image/hodgepodge/tabbuttom.png");
        background-size: 100% 100%;
        transform: scale(1.2);
      }
    }
  }
}
.views {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);
  .views_content::-webkit-scrollbar {
    display: none;
  }
  .views_content {
    width: 100%;
    height: calc(100% - 0.92rem);
    overflow: scroll;

    .views_banner {
      width: 100%;
      display: grid;

      img {
        width: 100%;
      }
    }

    .viewsTab::-webkit-scrollbar {
      display: none;
    }

    .viewsBoxTab {
      width: 100%;
    }

    .viewsTab {
      width: 100%;
      padding-bottom: 0.16rem;
      box-sizing: border-box;
      overflow-y: scroll;
      margin-top: -5%;

      ul {
        width: 100%;
        height: 1.2rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        // background: #d34a00;
        background: linear-gradient(to bottom, #ffe082 0%, #efbb69 100%);

        li {
          width: 33%;
          height: 100%;
          display: flex;
          align-content: center;
          align-items: center;
          flex-wrap: wrap;
          font-family: PingFang SC-Semibold, PingFang SC;
          line-height: 0.38rem;
          flex: 0 0 auto;
          cursor: pointer;

          div {
            width: 100%;
            font-size: 0.32rem;
            line-height: 1.2;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #903300;
          }
        }

        .select {
          font-weight: 600;
          // color: #903300;
          padding: 0.03rem 0;
          // background: url("~@/assets/image/hodgepodge/tabbuttom.png") no-repeat;
          // background-size: 100% 100%;
          background: linear-gradient(135deg, #ff8a3a 0%, #d34a00 100%);
          border-radius: 5px;
          box-shadow: 0 8px 20px rgba(211, 74, 0, 0.18), inset 0 -4px 12px rgba(255, 255, 255, 0.06);
          transform: translateZ(0) scale(1.04);
          transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;

          div {
            font-size: 0.32rem !important;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600 !important;
            color: #fff;
            line-height: 0.38rem !important;
          }
        }
      }
    }

    .viewTabContent {
      width: 100%;

      .ulsTab::-webkit-scrollbar {
        display: none;
      }

      .ulsTab {
        width: 100%;
        padding: 0.32rem 0 0 0.32rem;
        box-sizing: border-box;
        overflow-y: scroll;

        ul {
          width: 100%;
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;

          li {
            margin-right: 0.32rem;
            min-width: 2.4rem;
            max-width: 80%;
            height: 1.32rem;
            background: #ffffff;
            border: 0.04rem solid #ffffff;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            line-height: 0.38rem;
            flex: 0 0 auto;
            text-align: center;
            border-radius: 0.32rem;

            div {
              width: 100%;
              text-align: center;
            }

            div:nth-child(1) {
              font-size: 0.32rem;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              line-height: 0.38rem;
            }

            div:nth-child(2) {
              font-size: 0.26rem;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              line-height: 0.3rem;
              margin-top: 0.04rem;
            }
          }
          .select {
            background: #fdd472 !important;

            div:nth-child(1) {
              font-size: 0.32rem !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
              line-height: 0.38rem;
            }

            div:nth-child(2) {
              font-size: 0.26rem !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
              line-height: 0.3rem !important;
            }
          }
        }
      }

      .box {
        width: 100%;
        padding: 0.32rem;
        padding-top: 0.64rem;
        box-sizing: border-box;

        ul::-webkit-scrollbar {
          display: none;
        }

        ul {
          width: 100%;
          height: 70vh;
          border-radius: 0.16rem;
          background: #ffffff;
          border: 0.06rem solid #ffffff;
          box-sizing: border-box;
          overflow-x: hidden;
          position: relative;

          .wei {
            width: 100%;
            height: 0.92rem;
          }

          .weiyitop {
            width: 100%;
            height: 0.92rem;
            background: #ffb559;
            display: flex;
            position: sticky;
            left: 0;
            top: 0;

            div {
              width: 33%;
              text-align: center;
              font-size: 0.28rem;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #a94800;
              line-height: 0.92rem;
            }
          }

          .lis {
            width: 100%;
            height: 0.92rem;
            margin: auto;
            background: #ffffff;
            display: flex;
            border-bottom: 0.01rem;

            div {
              width: 33%;
              font-size: 0.28rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 0.92rem;
              text-align: center;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
          .wu_center_custom {
            width: 100%;
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.56rem;
            box-sizing: border-box;
            color: #666666;
            text-align: center;
            font-size: 0.32rem;
            line-height: 0.42rem;
          }
        .wu {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          align-content: center;

          img {
            width: 4.36rem;
            margin-bottom: 0.56rem;
          }

          span {
            width: 100%;
            font-size: 0.32rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 0.38rem;
          }
        }
      }
    }

    .viewsList {
      width: 100%;
      max-width: 1024px;
      margin: auto;
      margin-top: 64px;
      padding: 0.32rem;
      box-sizing: border-box;

      ul {
        width: 100%;

        li {
          width: 640px;
          height: 124px;
          margin: auto;
          background: #fff8de;
          box-shadow: 0px 0px 4px 0px rgba(126, 56, 0, 0.26);
          border: 4px solid #fff0e1;
          border-radius: 16px;
          margin-bottom: 32px;
          font-size: 24px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff782f;
          line-height: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.shortlisted-query {
  width: 90%;
  max-width: 600px;
  margin: 70px auto 0 auto;
  position: relative;
  .contentFrom_title {
    width: 80%;
    height: 50px;
    margin: auto;
    border-radius: 9px;
    background: url("~@/assets/image/icon/titlebg.png") no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 50px;
    position: absolute;
    top: -25px;
    left: 0;
    right: 0;
    margin: auto;

    text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
      1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
  }

  .plateUlsCentent6 {
    width: 100%;
    padding: 35px 12px 10px 12px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #ffffff;

    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;

      li {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;

        .prompt {
          height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          line-height: 10px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          padding-left: 13px;
          box-sizing: border-box;

          div {
            margin-right: 11px;
            text-align: center;
            line-height: 30px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 12px !important;
            color: #de2810;
          }
        }

        .lis {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background: #f5f5f5;
          display: flex;
          border-radius: 6px 6px 6px 6px;
          // overflow: hidden;

          .lisLife {
            display: flex;
            align-items: center;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #4a4a4a;
            padding-left: 10px;

            img {
              width: 16px;
              height: 11px;
            }
          }

          .lisRight {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }
        .row-input {
          display: flex;
          align-items: center;
          font-size: 0px;
        }
        .input-name {
          width: 22%;
          // height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          padding-left: 13px;
        }
        .input-name-1 {
          width: 25%;
          // height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          padding-left: 13px;
        }
        .promptInput {
          width: 100%;
          // width: 78%;
          box-sizing: border-box;
          padding-left: 13px;
          height: 34px;
          font-size: 14px;
          line-height: 34px;
          background: #f5f5f5;
          border: none;
          font-family: PingFang SC-Regular, PingFang SC;
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          // width: 75%;
          height: 34px;
          line-height: 34px;
          box-sizing: border-box;
          background: #f5f5f5;
          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 6px 6px 6px 6px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }
      }
    }

    .uls:first-child {
      margin-right: 60px;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      padding-bottom: 20px;
      margin: 20px auto 0 auto;
      transition: all 0.3s;
      &:active {
        transform: scale(1.02);
      }
    }
  }
}

.newShortBox {
  padding: 12px 0 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    .lis {
      width: 100%;
      margin-bottom: 20px;

      img {
        width: 149px;
      }
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: auto;
      font-size: 12px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 100%;
      padding: 0 12px;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px;

        li {
          width: 33.3%;
          text-align: center;
          font-size: 14px;
          padding: 5px;
        }
        li:nth-child(2) {
          width: 30% !important;
        }
      }

      ul:nth-child(1) {
        padding: 5px 0;
        background: #ff5a25;

        li {
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        margin-top: 10px;
        margin-bottom: 20px;

        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      padding: 0 12px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 1.5;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
.view_guide {
  margin: 0 auto;
  padding: 0 12px;
  line-height: 32px;
  background: #ff7e18;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  border-radius: 4px;
  color: #ffffff;
}

::v-deep .CountryCodeSelectorContainer {
  width: 100px;
  .arrow-down {
    width: 12px;
    height: 12px;
  }
}
</style>
